import { useCurrentSpace } from './use-current-space';

export const useIsCustomTemplate = (uuid: string) => {
  return useCurrentSpace().customTemplates?.includes(uuid);
};
